// extracted by mini-css-extract-plugin
module.exports = {"lia-build-wrap":"BuildInformation_lia-build-wrap__t_sty","lia-build-link":"BuildInformation_lia-build-link__QPxUg"};